import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import PayeeType from 'models/claims/payeeType/Model.PayeeType';
import { usePayeeProvider } from '../Payee.Hooks';

export default function PayeeFilters() {
  const { lang } = getLocales();
  const { listApi } = usePayeeProvider();
  const payeeTypeApi = useApi({ action: PayeeType.list });

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search, offset: 0 }))}
      onSortById={(sort) => listApi.execute((body) => ({ ...body, ...sort }))}
      filters={listApi.body}
      onFilter={(newFilers) => listApi.execute({ ...newFilers, offset: 0 })}
      onReset={listApi.reset}
      onOpen={() => {
        if (!payeeTypeApi.payload) payeeTypeApi.execute();
      }}
      render={({ tempFilters, setFilters }) => (
        <>
          <SelectInput
            name="payeeTypeId"
            label={lang.payeeTypes}
            data={payeeTypeApi?.payload?.data?.map((item) => item.displayInfo)}
            isMultiselect
            value={tempFilters?.payeeTypeId}
            onChange={({ payeeTypeId }) => setFilters({ ...tempFilters, payeeTypeId })}
            icon={<Icon class="fas-cloud" />}
          />
        </>
      )}
    />
  );
}
